import { createSlice } from '@reduxjs/toolkit';

type PendingPatientState = {
  geocodeResponse: any | null;
};

const initialState: PendingPatientState = {
  geocodeResponse: null
};

export const pendingPatientSlice = createSlice({
  name: 'pendingPatient',
  initialState,
  reducers: {
    setPendingPatientGeocodeResponse: (state, { payload }) => {
      state.geocodeResponse = payload ?? null;
    },
    clearPendingPatientGeocodeResponse: (state) => {
      state.geocodeResponse = null;
    }
  }
});

export const {
  setPendingPatientGeocodeResponse,
  clearPendingPatientGeocodeResponse
} = pendingPatientSlice.actions;

export const pendingPatientState = (state: any) => state.pendingPatient;

export default pendingPatientSlice.reducer;
